const OFFTRACK = "OFFTRACK"
const ONTRACK = "ONTRACK"
const NOTACTIVE = "NOTACTIVE"

export default {
    OFFTRACK: OFFTRACK,
    ONTRACK:ONTRACK,
    NOTACTIVE:NOTACTIVE
}